import React, { useEffect, useState } from 'react';
import { Box, Typography, Divider, CircularProgress } from '@mui/material';
import DocumentSectionTable from './DocumentationSectionTable';
import { getDocumentsCustomFields } from '../preboardingConfigurationApi';
import { useParams } from 'react-router-dom';
import { SectionProps } from '../CandidateDetailsConfiguration/CandidateDetailsConfiguration';


export interface CustomFieldType {
  customFieldId: number,
  name: string;
  mandatory: boolean;
  sectionId: number;
  sectionName: string;
}

const DocumentsConfiguration = () => {
  const { tenant } = useParams<{ tenant: string }>();
  const [governmentIdFields, setGovernmentIdFields] = useState<CustomFieldType[]>([]);
  const [addressFields, setAddressFields] = useState<CustomFieldType[]>([]);
  const [bankAccountFields, setBankAccountFields] = useState<CustomFieldType[]>([])
  const [academicQualificationFields, setAcademicQualificationFields] = useState<CustomFieldType[]>([])
  const [professionalDocumentFields, setProfessionalDocumentsFields] = useState<CustomFieldType[]>([])
  const [photoGraphFields, setPhotoGraphFields] = useState<CustomFieldType[]>([])
  const [sectionNames, setSectionNames] = useState<SectionProps[]>([])
  const [isLoading, setIsLoading] = useState(true);

  const fetchCustomFields = async () => {

    try {
      setIsLoading(true);
      const result = await getDocumentsCustomFields(tenant);
      if (result) {
        const transformedFields: CustomFieldType[] = result.Data.map((field: any) => ({
          customFieldId: field.CustomFieldId,
          name: field.FieldName,
          mandatory: field.IsMandatory,
          sectionName: field.SectionName,
          sectionId: field.SectionId,
        }));

        const sections: SectionProps[] = result.SectionNames.map((section: any) => ({
          sectionName: section.SectionName,
          sectionId: section.SectionId,
        }));

        setSectionNames(sections);

        // ✅ Filter based on sectionNames array indexes
        if (sections[0]) {
          setGovernmentIdFields(
            transformedFields.filter(field => field.sectionName === sections[0].sectionName)
          );
        }

        if (sections[1]) {
          setAddressFields(
            transformedFields.filter(field => field.sectionName === sections[1].sectionName)
          );
        }
        if (sections[2]) {
          setBankAccountFields(
            transformedFields.filter(field => field.sectionName === sections[2].sectionName)
          );
        }
        if (sections[3]) {
          setAcademicQualificationFields(
            transformedFields.filter(field => field.sectionName === sections[3].sectionName)
          );
        }

        if (sections[4]) {
          setProfessionalDocumentsFields(
            transformedFields.filter(field => field.sectionName === sections[4].sectionName)
          );
        }

        if (sections[5]) {
          setPhotoGraphFields(
            transformedFields.filter(field => field.sectionName === sections[5].sectionName)
          );
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }

  };


  useEffect(() => {
    fetchCustomFields()
  }, [tenant])

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        width="100%"
      >
        <CircularProgress />
      </Box>
    )
  }
  return (
    <Box width="100%">
      <Typography variant="h5" mt={2}>
        Identity Verification Documents
      </Typography>
      <Divider sx={{ my: 2 }} />

      <DocumentSectionTable
        fields={governmentIdFields}
        setFields={setGovernmentIdFields}
        sectionData={sectionNames[0]}
        isNew={true}
      />

      <DocumentSectionTable
        fields={addressFields}
        setFields={setAddressFields}
        sectionData={sectionNames[1]}
        isNew={true}
      />

      <DocumentSectionTable
        fields={bankAccountFields}
        setFields={setBankAccountFields}
        sectionData={sectionNames[2]}
        isNew={true}
      />

      <DocumentSectionTable
        fields={academicQualificationFields}
        setFields={setAcademicQualificationFields}
        sectionData={sectionNames[3]}
        isNew={true}
      />

      <DocumentSectionTable
        fields={professionalDocumentFields}
        setFields={setProfessionalDocumentsFields}
        sectionData={sectionNames[4]}
        isNew={true}
      />

      <DocumentSectionTable
        fields={photoGraphFields}
        setFields={setPhotoGraphFields}
        sectionData={sectionNames[5]}
        isNew={true}
      />
    </Box>
  );
};

export default DocumentsConfiguration;